// src/components/Chip.js
import styled from 'styled-components';
import { colors, fonts, fontSizes, radii, space } from '../styles/tokens';

export const Chip = styled.span`
  display: inline-block;
  padding: ${space[1]} ${space[2]};
  font-family: ${fonts.mono};
  font-size: ${fontSizes.xs};
  color: ${colors.textDim};
  background: ${colors.bgElev};
  border: 1px solid ${colors.border};
  border-radius: ${radii.full};
  letter-spacing: 0.05em;
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[1]};
  margin-top: ${space[3]};
`;
